import Modal from "../ui/Modal"
import { useEffect, useState } from "react"
import {
  ToggleButton,
  ToggleButtonGroup,
  Stack,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormLabel,
  FormControl,
  Select,
  MenuItem,
  Box,
} from "@mui/material"
import { DatePicker } from "../ui/DateTimePickers"
import FormItem from "../ui/FormItem"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"

const FilterModal = ({
  data,
  fetch,
  filterToggle,
  setFilterToggle,
  ...props
}) => {
  const handleFilterToggle = (_, val) => val && setFilterToggle(val)

  const [filter, setFilter] = useState({})

  const [sort, setSort] = useState({
    field: "",
    order: "asc",
  })

  const handleFilterChange = (ev, field, value) =>
    setFilter({
      ...filter,
      [field]: !ev.target.checked
        ? filter[field].filter((v) => v !== value)
        : [...(filter[field] || []), value],
    })

  const handleFilterDuration = (field, value) => {
    // utc string
    console.log(value)
    setFilter({
      ...filter,
      [field]: value.toISOString(),
    })
  }

  const handleSortChange = (ev) => {
    const { name, value } = ev.target
    setSort({
      ...sort,
      [name]: value,
    })
  }

  const initializeFilterSort = () => {
    setSort({
      ...sort,
      field: data?.sorts?.fields[0] || "",
    })
  }

  useEffect(() => {
    initializeFilterSort()
  }, [data])

  const apply = () => {
    fetch({
      filter: Object.keys(filter)
        .filter((key) => filter[key].length)
        .reduce((res, key) => {
          res[key] = filter[key]
          return res
        }, {}),
      sort,
    })
    props.close()
  }

  return (
    <Modal
      {...props}
      action={apply}
      actionText={filterToggle === "filter" ? "Apply filters" : "Sort Data"}
    >
      <Stack direction="row" justifyContent="center">
        <ToggleButtonGroup
          value={filterToggle}
          exclusive
          onChange={handleFilterToggle}
          aria-label="text alignment"
        >
          <ToggleButton value="filter">Filter</ToggleButton>
          <ToggleButton value="sort">Sort</ToggleButton>
        </ToggleButtonGroup>
      </Stack>
      <Stack spacing={2} paddingTop={2}>
        {filterToggle === "filter" ? (
          <>
            {data?.filters
              ?.filter(({ values }) => Array.isArray(values))
              .map(
                ({ field, values }) =>
                  field !== "from" &&
                  field !== "to" && (
                    <Box key={field}>
                      <FormLabel>{field}</FormLabel>
                      {Array.isArray(values) && (
                        <FormGroup row>
                          {values?.map((value, i) => (
                            <FormControlLabel
                              key={i}
                              checked={
                                filter?.hasOwnProperty(field) &&
                                filter[field].includes(value)
                              }
                              onChange={(ev) =>
                                handleFilterChange(ev, field, value)
                              }
                              control={<Checkbox />}
                              label={value}
                            />
                          ))}
                        </FormGroup>
                      )}
                    </Box>
                  )
              )}
            <Box>
              <FormLabel>{"duration"}</FormLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <FormGroup row>
                  <Box className="row">
                    <Box sx={{ mr: "1rem" }}>
                      <FormItem label="from">
                        <DatePicker
                          name={"from"}
                          value={
                            filter && filter.from
                              ? filter.from
                              : dayjs().toISOString()
                          }
                          onChange={(date) =>
                            handleFilterDuration("from", date)
                          }
                        />
                      </FormItem>
                    </Box>
                    <Box sx={{ ml: "1rem" }}>
                      <FormItem label="to">
                        <DatePicker
                          value={
                            filter && filter.to
                              ? filter.to
                              : dayjs().toISOString()
                          }
                          name={"to"}
                          onChange={(date) => handleFilterDuration("to", date)}
                        />
                      </FormItem>
                    </Box>
                  </Box>
                </FormGroup>
              </LocalizationProvider>
            </Box>
          </>
        ) : (
          <>
            <FormControl fullWidth>
              <FormLabel sx={{ mb: 1 }}>SORT BY FIELD</FormLabel>
              <Select
                name="field"
                value={sort.field}
                onChange={handleSortChange}
              >
                {data?.sorts?.fields.map((sort, i) => (
                  <MenuItem key={i} value={sort}>{sort}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <FormLabel sx={{ mb: 1 }}>SORT ORDER</FormLabel>
              <Select
                name="order"
                value={sort.order}
                onChange={handleSortChange}
              >
                <MenuItem value={"asc"}>Ascending</MenuItem>
                <MenuItem value={"desc"}>Descending</MenuItem>
              </Select>
            </FormControl>
          </>
        )}
      </Stack>
    </Modal>
  )
}

export default FilterModal
